import React from 'react';
import { StyleSheet, View } from 'react-native';
import { RadioButton } from '../../../../helperComponents/RadioButton';
import { getColors } from '../../../../../constants/colors';

export enum NotificationTargets {
    all = 'all',
    inStudy = 'inStudy',
    notPlayed = 'notPlayed',
}

const targetLabels = {
    [NotificationTargets.all]: 'All Users',
    [NotificationTargets.notPlayed]: 'Users who have not played the quarter',
    [NotificationTargets.inStudy]: 'Users in study',
};

interface NotificationTargetRadioGroupProps {
    selectedTarget: NotificationTargets;
    onTargetChange: (target: NotificationTargets) => void;
}

const COLORS = getColors();

export function TargetRadioGroup({
    selectedTarget,
    onTargetChange,
}: NotificationTargetRadioGroupProps) {
    return (
        <View style={styles.container}>
            <View style={styles.radioGroup}>
                {Object.values(NotificationTargets).map((target) => (
                    <View key={target} style={styles.radioOption}>
                        <View style={styles.radioButtonWrapper}>
                            <RadioButton
                                value={target}
                                groupValue={selectedTarget}
                                setGroupValue={onTargetChange}
                                radioText={targetLabels[target]}
                                containerStyle={styles.radioButtonContainer}
                            />
                        </View>
                    </View>
                ))}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 15,
    },
    radioGroup: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
    },
    radioOption: {
        marginBottom: 10,
        marginRight: 40,
    },
    radioButtonWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    radioButtonContainer: {
        marginLeft: 10,
    },
});
